module.exports = __webpack_public_path__ + "static/media/referencePointOff.df83ec25.svg";